import mapButtonProps from './mapButtonProps';

function mapCardsData(inputCards = []) {
  return inputCards.map(card => {
    const result: any = {
      id: card.id,
      title: card.title,
      description: card.description,
      image: {
        src: card.imgSrc,
        alt: card.imgAlt,
      },
    };

    if (card.buttonLabel) {
      result.buttonProps = {
        label: card.buttonLabel,
        ariaLabel: card.buttonAriaLabel,
        mobileUrl: card.buttonMobileUrl,
        landingCategory: card.buttonLandingCategory,
        tabIndex: card.buttonTabIndex,
      };
      result.qrModal = {
        title: card.qrModalTitle,
        stores: [],
      };
      if (card.qrModalAppleStoreQrCode) {
        result.qrModal.stores.push({
          qr: card.qrModalAppleStoreQrCode,
          icon: 'apple-mono-gen',
          storeName: 'App Store',
        });
      }
      if (card.qrModalGooglePlayQrCode) {
        result.qrModal.stores.push({
          qr: card.qrModalGooglePlayQrCode,
          icon: 'google-play-brand',
          storeName: 'Google Play',
        });
      }
      if (card.qrModalMicrosoftStoreQrCode) {
        result.qrModal.stores.push({
          qr: card.qrModalMicrosoftStoreQrCode,
          icon: 'microsoft-brand',
          storeName: 'Microsoft Store',
        });
      }
    }

    return result;
  });
}

export default function getIconBlockWithCtasMapper(componentsData) {
  return mapButtonProps({
    ...componentsData,
    cards: mapCardsData(componentsData.cards),
  });
}
